import isNumber from 'lodash/isNumber';

import { MAX_IN_RESTAURANT_CART_QUANTITY, MIN_IN_RESTAURANT_CART_QUANTITY } from './constants';
import type { ILegacyCartEntry } from './incentive-cart';
import { ICartEntryType } from './incentive-cart';

export const isStackableOffer = (cartEntry: ILegacyCartEntry): boolean =>
  cartEntry.type === ICartEntryType.OFFER && !!cartEntry.details.offer.isStackable;

export const isCartEntryQuantityValid = (quantity: unknown) =>
  isNumber(quantity) &&
  quantity <= MAX_IN_RESTAURANT_CART_QUANTITY &&
  quantity >= MIN_IN_RESTAURANT_CART_QUANTITY;
